import { gql } from '@apollo/client';
/**
 * @fragment AssetCategoryFragment
 * @since 1.0.0
 */
export const AssetCategoryFragment = gql `
  fragment AssetCategoryFragment on AssetCategory {
    id
    title
    infos
    createdAt
    updatedAt
  }
`;
